import { memo } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { SmartTagsFilterCard } from '~/components/Filters/SmartTagsFilter/SmartTagsFilterCard';
import { PrivateSmartTagsSelect } from '~/components/SmartTagSelect/PrivateSmartTagsSelect';

export const PrivateSmartTagsFiltersCard = memo((props: BaseFilterCardProps) => (
  <SmartTagsFilterCard SmartTagsSelect={PrivateSmartTagsSelect} {...props} />
));

PrivateSmartTagsFiltersCard.displayName = 'PrivateSmartTagsFiltersCard';
